export default {
  customerImport: {
    title: 'Thank You for Your Interest!',
    description:
      "We're excited to bring you early access to our Customer Import feature. Stay tuned—we'll be in touch soon with more details!",
    btnLabel: 'Go to the Dashboard'
  },
  merchantAppInterest: {
    title: 'Thank You for Your Interest!',
    description:
      "We're excited to bring you early access to our Merchant's App. Stay tuned—we'll be in touch soon with more details!",
    btnLabel: 'Go to the Dashboard'
  }
};
